import script from "./ProfileHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileHeader.vue?vue&type=style&index=0&id=67cfd568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cfd568"]])

export default __exports__